import { Back } from "iconsax-reactjs";
import MicroModal from "micromodal";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SearchingHistoryDataByReplyid } from "../../../actions";

export const useReplyOtherCdr = (replyInOtherCdr) => {
  const dispatch = useDispatch();
  const informationusers = useSelector((state) => state.informationusers);
  const [isLoading, setIsLoading] = useState(false);

  const handleGetCdrByReplyId = async () => {
    setIsLoading(true);
    dispatch(
      SearchingHistoryDataByReplyid(
        replyInOtherCdr ? replyInOtherCdr.id : "",
        informationusers ? informationusers.idgroup : "",
      ),
    );
    MicroModal.show("modal__historico-atendimento-contact-2");
    setIsLoading(false);
  };
  const renderReplyInOtherCdr = () => {
    return (
      <button
        className="comment-principal__btn-reply-in-other-cdr"
        onClick={handleGetCdrByReplyId}
      >
        <Back size="16" color="#263d76" />
        <span>Ver mensagem anterior</span>
      </button>
    );
  };

  return { renderReplyInOtherCdr };
};
